var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.show,
        title: "款号：" + _vm.goods_kh,
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.show = $event
        }
      }
    },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.list, border: "", size: "small" } },
        [
          _c("el-table-column", {
            attrs: { prop: "plan_price", label: "代采单价", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "co_val", label: "颜色", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "si_val", label: "尺码", align: "center" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "选择开单", align: "center", width: "160px" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("el-input-number", {
                      attrs: { size: "small", min: 0 },
                      model: {
                        value: scope.row.cg_num,
                        callback: function($$v) {
                          _vm.$set(scope.row, "cg_num", $$v)
                        },
                        expression: "scope.row.cg_num"
                      }
                    })
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "剩余", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "curosr full",
                            attrs: { type: "text" },
                            on: {
                              click: function($event) {
                                return _vm.tapLeftNum(scope.row)
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.calcLeftNum(scope.row)) +
                                "\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "前置数量", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.calcDkNum(scope.row)) +
                          "\n        "
                      )
                    ])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "20%", margin: "0" },
              attrs: { type: "infor" },
              on: { click: _vm.orderNumReset }
            },
            [_vm._v("重置")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "20%", margin: "0" },
              attrs: { type: "danger" },
              on: { click: _vm.orderNumAll }
            },
            [_vm._v("全选")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticStyle: { width: "55%", margin: "0" },
              attrs: { type: "primary" },
              on: { click: _vm.orderNumConfirm }
            },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6897c929", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6897c929","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/purchaseverify/components/KdDialog.vue
// module id = null
// module chunks = 